<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableApps/>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="createItem()">Neu erstellen</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TableApps from "../tables/TableApps"

export default {
  name: 'Apps',
  components: {TableApps},
  data () {
    return {}
  },
  methods: {
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$api.createApp({}, this.onAppCreated)
    },
    onAppCreated: function (newItem) {
      console.log('onAppCreated', newItem)
      this.$router.push('/Apps/' + newItem.guid)
    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
